/** Mirrors the backend recipient types of a `recipients` param. */
export enum ReflectionRecipientTypeEnum {
  REQUESTER = 'requester',
  STEP_ASSIGNEES = 'step_assignees',
  USERS = 'users',
  USER_FIELD = 'user_field',
}
